import React, { FunctionComponent, memo, SyntheticEvent } from 'react'

import { Input } from './atoms'

interface Props {
  type?: 'text' | 'tel' | 'password'
  hasError?: boolean
  id: string
  value: string
  disablePaste?: boolean
  isDisabled?: boolean
  onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const TextInput: FunctionComponent<Props> = ({ type = 'text', hasError, id, disablePaste, isDisabled, ...rest }) => {
  const handleDisablePaste = (event: SyntheticEvent): void => event.preventDefault()

  return (
    <Input
      id={id}
      type={type}
      error={hasError ? hasError : undefined}
      autoComplete="off"
      onPaste={disablePaste ? handleDisablePaste : undefined}
      isDisabled={isDisabled}
      {...rest}
    />
  )
}

TextInput.displayName = 'TextInput'

export default memo(TextInput)
